<template>
    <!--弹窗-->
    <el-dialog
        :visible="visible"
        width="500px"
        title="新增词根单复数"
        :before-close="handleClose"
        append-to-body
    >
        <el-form ref="formData" label-width="120px" size="mini" :rules="rules" :model="formData">

            <el-form-item label="单词：" class="query-form-item" prop="keyword">
                <el-input style="width: 220px;" clearable v-model="formData.keyword" placeholder="请输入单词"
                          size="mini"></el-input>
            </el-form-item>

            <el-form-item label="单复数形式：" class="query-form-item" prop="plural_keywords">
                <el-input style="width: 220px;" clearable v-model="formData.plural_keywords" placeholder="单复数形式,多个值用','拼接"
                          size="mini"></el-input>
            </el-form-item>

        </el-form>
        <el-row style="margin-top: 17px">
            <el-button
                style="float: right; margin-left: 6px"
                size="mini"
                type="danger"
                plain
                @click="handleClose(false)"
            >取 消
            </el-button
            >
            <el-button
                style="float: right"
                size="mini"
                type="primary"
                @click="submitForm('formData')"
                :loading="loading"
            >确定
            </el-button
            >
        </el-row>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/Product/Product'

    export default {
        data() {
            return {
                visible: false,
                loading: false,
                formData: {},
                rules: {
                    keyword: [{required: true, message: '请输入单词', trigger: 'blur'},],
                    plural_keywords: [{required: true, message: '请输入单复数形式', trigger: 'blur'},],
                },
            }
        },
        methods: {
            openModal() {
                this.visible = true
            },
            // 保存信息
            submitForm() {
                this.$refs.formData.validate(valid => {
                    if (valid) {
                        this.loading = true
                        api.seed_word_asin_list_add_singular_plural(this.formData).then((res) => {
                            if (res.success) {
                                this.$message.success('新增成功')
                                this.handleClose()
                            } else {
                                this.$message.error(res.message)
                            }
                        }).finally(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            // 关闭弹窗
            handleClose() {
                this.visible = false
                this.formData = {}
                this.$emit('close')
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .download {
        display: flex;
        justify-content: center;
    }
</style>
